/* Biotherapy Care : theme.js */
(function () {
  'use strict';

  /* Questionnaire diagnostic (Typeform) : ouvert dans un nouvel onglet pour ne
     pas faire quitter la boutique. Couvre le menu, le bouton du tiroir mobile,
     la carte du méga-menu et la section diagnostic. */
  document.querySelectorAll('a[href*="typeform.com"]').forEach(function (a) {
    a.target = '_blank';
    a.rel = 'noopener';
  });

  /* Vidéo de présentation.
     - Rien n'est téléchargé au chargement de la page (preload="none", affiche seule).
     - Le fichier est choisi et chargé quand la section approche de l'écran :
       version légère (data-sd) en économie de données ou connexion lente, et
       pour une vidéo horizontale sur petit écran (data-sd-below), sinon pleine
       définition (data-hd).
     - Lecture muette en boucle quand la vidéo est visible, pause hors écran.
     - Moins d'animations demandé : pas de lecture auto, commandes affichées. */
  (function () {
    var wraps = document.querySelectorAll('[data-bvideo]');
    if (!wraps.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    var light = !!(conn && (conn.saveData || /(^|-)2g|3g/.test(conn.effectiveType || '')));
    var hasIO = 'IntersectionObserver' in window;

    wraps.forEach(function (wrap) {
      var video = wrap.querySelector('video');
      var btn = wrap.querySelector('[data-bvideo-sound]');
      if (!video) return;
      video.muted = true;

      var loaded = !video.dataset.hd; // vidéo Shopify classique : sources déjà en place
      var load = function () {
        if (loaded) return;
        loaded = true;
        // Vidéo horizontale : la version 720p suffit sous 990 px de large (téléphone)
        var narrow = video.dataset.sdBelow && window.innerWidth < parseInt(video.dataset.sdBelow, 10);
        video.src = ((light || narrow) && video.dataset.sd) ? video.dataset.sd : video.dataset.hd;
        video.load();
      };
      var play = function () {
        load();
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      };

      if (reduce) {
        video.controls = true;
        if (btn) btn.hidden = true;
        if (hasIO) {
          new IntersectionObserver(function (entries, obs) {
            if (entries[0].isIntersecting) { load(); obs.disconnect(); }
          }, { rootMargin: '300px 0px' }).observe(wrap);
        } else { load(); }
        return;
      }

      if (btn) {
        btn.addEventListener('click', function () {
          var on = video.muted;
          video.muted = !on;
          if (on) play();
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          btn.setAttribute('aria-label', on ? 'Couper le son' : 'Activer le son');
        });
      }

      if (hasIO) {
        // Préchargement un peu avant l'arrivée à l'écran, pour démarrer sans attente
        new IntersectionObserver(function (entries, obs) {
          if (entries[0].isIntersecting) { load(); obs.disconnect(); }
        }, { rootMargin: '400px 0px' }).observe(wrap);
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { play(); } else if (!video.paused) { video.pause(); }
          });
        }, { threshold: 0.25 }).observe(wrap);
      } else {
        play();
      }
    });
  })();

  /* Tiroir mobile : occupe toute la hauteur sous l'en-tête et bloque le
     défilement de la page derrière, pour qu'on ne voie plus le contenu
     dépasser sous le menu. */
  (function () {
    var drawer = document.querySelector('details.drawer');
    if (!drawer) return;
    var wrap = drawer.closest('.header-wrap');
    var place = function () {
      var top = wrap ? Math.max(0, wrap.getBoundingClientRect().bottom) : 0;
      document.documentElement.style.setProperty('--drawer-top', top + 'px');
    };
    drawer.addEventListener('toggle', function () {
      if (drawer.open) place();
      document.documentElement.classList.toggle('drawer-open', drawer.open);
    });
    window.addEventListener('resize', function () {
      if (!drawer.open) return;
      if (window.matchMedia('(min-width: 1100px)').matches) { drawer.open = false; return; }
      place();
    });
  })();

  /* Formatage monétaire partagé (sélecteur de variantes, upsell).
     Même format que le filtre Liquid « money » (format de la boutique, ex. €23,90),
     pour que le bouton et les prix affichés à côté s'écrivent pareil. */
  var money = function (cents, currency) {
    var fmt = window.BT_MONEY_FORMAT;
    if (!fmt) {
      return (cents / 100).toLocaleString(document.documentElement.lang || 'fr', { style: 'currency', currency: currency || 'EUR' });
    }
    var fix = function (d, ts, ds) {
      var p = (cents / 100).toFixed(d).split('.');
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (p[1] ? ds + p[1] : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount_no_decimals': return fix(0, ',', '.');
        case 'amount_with_comma_separator': return fix(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fix(0, '.', ',');
        case 'amount_with_apostrophe_separator': return fix(2, "'", '.');
        case 'amount_with_space_separator': return fix(2, ' ', ',');
        default: return fix(2, ',', '.');
      }
    });
  };

  /* Libellé du bouton d'ajout : « Ajouter au panier » + « · prix ».
     Deux morceaux pour que le CSS puisse masquer le prix sur petit écran
     (il est déjà affiché au-dessus du bouton). */
  var setAddLabel = function (addBtn, priceText) {
    var span = addBtn && addBtn.querySelector('span');
    if (!span) return;
    span.textContent = '';
    if (priceText == null) { span.textContent = addBtn.dataset.labelSold; return; }
    var l = document.createElement('span');
    l.setAttribute('data-add-label', '');
    l.textContent = addBtn.dataset.labelAdd;
    var p = document.createElement('span');
    p.className = 'atc-price';
    p.setAttribute('data-add-price', '');
    p.textContent = ' · ' + priceText;
    span.appendChild(l);
    span.appendChild(p);
  };

  /* Disponibilité affichée sous le bouton : suit la variante choisie. */
  var updateStock = function (wrap, variant) {
    var box = wrap.querySelector('[data-stock]');
    if (!box) return;
    var text = box.querySelector('[data-stock-text]');
    var mapEl = box.querySelector('[data-stock-map]');
    var map = {};
    try { map = JSON.parse(mapEl ? mapEl.textContent : '{}'); } catch (err) { map = {}; }
    var info = map[String(variant.id)] || {};
    var low = parseInt(box.dataset.low, 10) || 5;
    var label;
    if (!variant.available) label = box.dataset.labelOut;
    else if (info.tracked && info.qty <= low) label = box.dataset.labelLow.replace('[n]', info.qty);
    else label = box.dataset.labelIn;
    if (text) text.textContent = label;
  };

  /* Rappel des vidéos témoignages en pastilles, dans la colonne produit.
     Construit depuis les vignettes de la section, pas depuis une seconde source :
     les data-story-open pointent sur les memes <dialog>, donc le clic est deja gere
     par la delegation ci-dessous. Rien a contribuer deux fois. */
  (function () {
    var host = document.querySelector('[data-stories-row]');
    var tiles = document.querySelectorAll('.stories__grid .story[data-story-open]');
    if (!host || !tiles.length) return;
    Array.prototype.forEach.call(tiles, function (tile) {
      var img = tile.querySelector('img');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pstories__item';
      b.setAttribute('data-story-open', tile.getAttribute('data-story-open'));
      var label = tile.querySelector('.story__label');
      b.setAttribute('aria-label', 'Voir la vidéo' + (label ? ' : ' + label.textContent.trim() : ''));
      if (img) {
        var c = document.createElement('img');
        c.src = img.currentSrc || img.src;
        c.alt = '';
        c.loading = 'lazy';
        b.appendChild(c);
      }
      var icon = tile.querySelector('.story__play svg');
      if (icon) {
        var p = document.createElement('span');
        p.className = 'pstories__play';
        p.appendChild(icon.cloneNode(true));
        b.appendChild(p);
      }
      host.appendChild(b);
    });
    host.closest('[data-stories-mini]').hidden = false;
  })();

  /* Stories vidéo : <dialog> fournit le fond, le piégeage du focus et Échap.
     Il ne reste qu'à ouvrir, fermer, et arrêter la lecture à la fermeture.
     Safari avant 15.4 ne connaît pas <dialog> : on pose alors l'attribut open et
     une classe de repli qui positionne la fenêtre à la main (voir la CSS). Dans
     ce mode, Échap et l'arrêt de la vidéo sont gérés ici, faute d'événement close. */
  var stopVideo = function (dlg) {
    var v = dlg.querySelector('video');
    if (v) { v.pause(); v.currentTime = 0; }
  };
  var openDialog = function (dlg) {
    if (dlg.showModal) { dlg.showModal(); return; }
    dlg.setAttribute('open', '');
    dlg.classList.add('is-fallback');
  };
  var closeDialog = function (dlg) {
    if (!dlg) return;
    if (dlg.close && !dlg.classList.contains('is-fallback')) { dlg.close(); return; }
    dlg.removeAttribute('open');
    dlg.classList.remove('is-fallback');
    stopVideo(dlg);
  };

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-story-open]');
    if (open) {
      var dlg = document.getElementById(open.getAttribute('data-story-open'));
      if (!dlg) return;
      openDialog(dlg);
      var v = dlg.querySelector('video');
      /* Affiche posée seulement à l'ouverture : en attribut direct, le navigateur la
         téléchargeait au chargement de la fiche alors que la fenêtre est fermée. */
      if (v && v.dataset.poster && !v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster);
      if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      return;
    }
    var closer = e.target.closest('[data-dialog-close]');
    if (closer) { closeDialog(closer.closest('dialog')); return; }
    /* Clic sur le fond : la cible est le <dialog> lui-même, pas son contenu.
       Nos fenêtres ont padding:0, seul le fond peut donc recevoir ce clic. */
    if (e.target.tagName === 'DIALOG') closeDialog(e.target);
  });

  /* Échap : natif avec <dialog>, à la main en repli. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.keyCode !== 27) return;
    var dlg = document.querySelector('dialog.is-fallback');
    if (dlg) closeDialog(dlg);
  });

  /* L'événement close ne remonte pas : on l'écoute en phase de capture. */
  document.addEventListener('close', function (e) {
    if (!e.target.classList || !e.target.classList.contains('story-modal')) return;
    stopVideo(e.target);
  }, true);

  /* Popup newsletter. <dialog> gère le fond, le focus et Échap ; il ne reste que la
     décision d'ouvrir. Mémoire dans localStorage :
       'done'      inscrit, on ne redemande plus ;
       'sent'      formulaire envoyé, on attend le rechargement de la page ;
       horodatage  fermée sans inscription, relance après data-again jours. */
  (function () {
    var dlg = document.getElementById('nlp');
    if (!dlg || !dlg.showModal) return;

    var KEY = 'bt_nlp';
    /* Navigation privée ou stockage bloqué : on se tait plutôt que de harceler. */
    var read = function () { try { return localStorage.getItem(KEY); } catch (e) { return 'done'; } };
    var write = function (v) { try { localStorage.setItem(KEY, v); } catch (e) {} };
    var open = function () { if (!dlg.open && document.body.contains(dlg)) dlg.showModal(); };

    dlg.addEventListener('submit', function () { write('sent'); });
    dlg.addEventListener('close', function () { if (read() !== 'done') write(String(Date.now())); });

    /* Éditeur de thème : suivre la sélection, sinon le pied de page devient inéditable. */
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(dlg)) open(); });
      document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(dlg)) dlg.close(); });
      return;
    }

    var stored = read();
    if (stored === 'done') return;

    /* Le formulaire client recharge la page : le panneau code remplace les champs. */
    if (dlg.querySelector('[data-nlp-success]')) {
      if (stored === 'sent') { write('done'); open(); }
      return;
    }

    var closedAt = parseInt(stored, 10);
    if (closedAt) {
      var again = (parseInt(dlg.dataset.again, 10) || 0) * 864e5;
      if (!again || Date.now() - closedAt < again) return;
    }
    setTimeout(open, (parseInt(dlg.dataset.delay, 10) || 0) * 1000);
  })();

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-nlp-copy]');
    if (!b || !navigator.clipboard) return;
    navigator.clipboard.writeText(b.getAttribute('data-code')).then(function () {
      var l = b.querySelector('.nlp__copy');
      if (l) l.textContent = l.getAttribute('data-done') || l.textContent;
    }, function () {});
  });

  /* Comparateur avant/après : le curseur natif pilote --pos, donc utilisable au clavier.
     Délégué, sans initialisation : marche pour toute carte ajoutée par l'éditeur de thème. */
  document.addEventListener('input', function (e) {
    var range = e.target;
    if (!range.classList || !range.classList.contains('ba__range')) return;
    var media = range.closest('.ba__media');
    if (media) media.style.setProperty('--pos', range.value + '%');
  });

  /* Quantité (+/−) et galerie produit : délégation globale */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (btn) {
      var input = btn.closest('.qty').querySelector('input');
      var min = parseInt(input.min || '1', 10);
      var step = btn.dataset.qty === '+' ? 1 : -1;
      input.value = Math.max(min, (parseInt(input.value, 10) || min) + step);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (thumb) showThumb(thumb);
  });

  var showThumb = function (thumb) {
    var main = document.querySelector('[data-gallery-main] img');
    if (main) {
      main.src = thumb.dataset.src; main.removeAttribute('srcset'); main.classList.toggle('is-contain', thumb.dataset.fit === 'contain');
      /* Produit détouré (PNG transparent) : pas de cadre coloré derrière */
      main.parentNode.classList.toggle('is-cut', thumb.dataset.cut === '1');
    }
    var strip = thumb.closest('.gallery__thumbs');
    strip.querySelectorAll('.is-active').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
    /* Sur mobile les vignettes défilent en bandeau : on garde l'active en vue */
    if (strip.scrollWidth > strip.clientWidth) {
      strip.scrollTo({ left: thumb.offsetLeft - (strip.clientWidth - thumb.offsetWidth) / 2, behavior: 'smooth' });
    }
  };

  /* Balayage horizontal sur la grande image (mobile) : image suivante / précédente */
  (function () {
    var main = document.querySelector('[data-gallery-main]');
    if (!main) return;
    var x0 = null, y0 = null;
    main.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-gallery-thumb]'));
      if (thumbs.length < 2) return;
      var i = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
      var next = (i + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length;
      showThumb(thumbs[next]);
    }, { passive: true });
  })();

  /* Panier : soumission auto quand la quantité change */
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    cartForm.addEventListener('change', function (e) {
      if (e.target.matches('.qty input')) cartForm.submit();
    });
  }

  /* Filtres collection : soumission auto */
  var facets = document.querySelector('[data-facets]');
  if (facets) {
    facets.addEventListener('change', function () { facets.submit(); });
  }

  /* Sélecteur de variantes */
  document.querySelectorAll('[data-product-form]').forEach(function (wrap) {
    var jsonEl = wrap.querySelector('[data-variants]');
    if (!jsonEl) return;
    var variants = JSON.parse(jsonEl.textContent);
    var cur = wrap.dataset.currency;
    wrap.addEventListener('change', function (e) {
      if (!e.target.matches('.opts input')) return;
      var selected = Array.prototype.map.call(wrap.querySelectorAll('.opts fieldset'), function (f) {
        var checked = f.querySelector('input:checked');
        return checked ? checked.value : null;
      });
      var variant = variants.find(function (v) {
        return selected.every(function (val, i) { return v.options[i] === val; });
      });
      if (!variant) return;
      var idInput = wrap.querySelector('input[name="id"]');
      if (idInput) idInput.value = variant.id;
      var price = wrap.querySelector('[data-price]');
      if (price) price.textContent = money(variant.price, cur);
      var compare = wrap.querySelector('[data-compare]');
      if (compare) compare.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price, cur) : '';
      var addBtn = wrap.querySelector('[data-add]');
      if (addBtn) {
        addBtn.disabled = !variant.available;
        setAddLabel(addBtn, variant.available ? money(variant.price, cur) : null);
      }
      updateStock(wrap, variant);
      history.replaceState(null, '', '?variant=' + variant.id);
    });
  });

  /* Compléter le rituel : ajout groupé du produit + des produits du palier choisi.
     Sans JS, le formulaire ajoute normalement le produit seul. */
  document.querySelectorAll('[data-upsell]').forEach(function (box) {
    var form = box.closest('form[action$="/cart/add"]');
    var wrap = box.closest('[data-product-form]');
    if (!form || !wrap) return;
    var payBtn = form.querySelector('.shopify-payment-button');
    var addBtn = form.querySelector('[data-add]');
    var jsonEl = wrap.querySelector('[data-variants]');
    var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];

    var chosen = function () { return box.querySelector('input[type="radio"]:checked'); };
    var picked = function () {
      var r = chosen();
      return r && r.value ? r.value.split(',') : [];
    };

    /* Montant du bouton = variante × quantité + produits du palier, remise déduite.
       Attaché à [data-product-form] pour passer après le sélecteur de variantes,
       qui réécrit ce même libellé. */
    var refresh = function () {
      if (payBtn) payBtn.style.display = picked().length ? 'none' : '';
      if (!addBtn || addBtn.disabled) return;
      var idInput = form.querySelector('input[name="id"]');
      var qtyInput = form.querySelector('input[name="quantity"]');
      if (!idInput) return;
      var variant = variants.find(function (v) { return String(v.id) === String(idInput.value); });
      if (!variant) return;
      var r = chosen();
      var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
      var total = variant.price * qty + (parseInt(r && r.dataset.addons, 10) || 0);
      var pct = parseInt(r && r.dataset.pct, 10) || 0;
      total -= Math.floor(total * pct / 100);
      setAddLabel(addBtn, money(total, wrap.dataset.currency));
    };

    wrap.addEventListener('change', refresh);
    refresh();

    form.addEventListener('submit', function (e) {
      var extras = picked();
      if (!extras.length) return;
      e.preventDefault();
      var idInput = form.querySelector('input[name="id"]');
      var qtyInput = form.querySelector('input[name="quantity"]');
      if (!idInput) return;
      var items = [{ id: idInput.value, quantity: parseInt(qtyInput && qtyInput.value, 10) || 1 }];
      extras.forEach(function (id) { items.push({ id: id, quantity: 1 }); });
      if (addBtn) addBtn.disabled = true;
      fetch(box.dataset.addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location = box.dataset.cartUrl;
        })
        .catch(function () {
          if (addBtn) addBtn.disabled = false;
          form.submit(); /* repli : ajoute au moins le produit principal */
        });
    });
  });

  /* Recommandations produit (Section Rendering API) */
  document.querySelectorAll('[data-recommendations]').forEach(function (el) {
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var inner = doc.querySelector('[data-recommendations]');
        if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
        /* badges Judge.me des cartes injectées : le script est déjà chargé, il faut le relancer */
        if (window.jdgm && typeof jdgm.batchSetup === 'function') jdgm.batchSetup();
      })
      .catch(function () {});
  });

  /* Adresses : provinces dépendantes du pays */
  document.querySelectorAll('select[data-country]').forEach(function (sel) {
    var wrapEl = document.getElementById(sel.dataset.provinceWrap || '');
    var provSel = wrapEl ? wrapEl.querySelector('select') : null;
    function update() {
      if (!provSel) return;
      var opt = sel.options[sel.selectedIndex];
      var provinces = JSON.parse((opt && opt.dataset.provinces) || '[]');
      provSel.innerHTML = provinces.map(function (p) {
        var selAttr = p[0] === provSel.dataset.default ? ' selected' : '';
        return '<option value="' + p[0] + '"' + selAttr + '>' + p[1] + '</option>';
      }).join('');
      wrapEl.style.display = provinces.length ? '' : 'none';
    }
    if (sel.dataset.default) sel.value = sel.dataset.default;
    sel.addEventListener('change', update);
    update();
  });

  /* Motion au scroll : révélations, parallaxe, texte scrubbé.
     Sans JS ou en reduced-motion, tout reste visible et immobile. */
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    var toReveal = [];
    var mark = function (el, cls, delay) {
      el.classList.add(cls);
      if (delay) el.style.setProperty('--rvd', delay + 'ms');
      toReveal.push(el);
    };

    /* Blocs éditoriaux : fondu + légère montée.
       Les cadres à parallaxe (rituels, diagnostic) montent comme des blocs :
       l'image intérieure reste pilotée par --plx sans conflit de transition. */
    [
      '.section-head', '.page-hero__content', '.iwt__content',
      '.band__grid > :not(.band__media)', '.cta-band__body',
      '.image-banner__content', '.newsletter__inner', '.rituels__foot',
      '.video-section__cta', '.coll-banner > *', '.rituel__media', '.diag__card',
      '.vhist__body', '.vhist__media', '.vcroy__title', '.exrit__body'
    ].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) { mark(el, 'rv-block', 0); });
    });

    /* Héro : entrée orchestrée (badge, titre, texte, actions, puis l'image) */
    document.querySelectorAll('.hero__content > *').forEach(function (el, i) {
      mark(el, 'rv-block', i * 90);
    });
    document.querySelectorAll('.hero__media').forEach(function (el) {
      mark(el, 'rv-block', 180);
    });

    /* Pages marque : même orchestration pour les héros et la bande d'engagement
       (sur-titre, titre, texte, puis l'image ou le bouton) */
    document.querySelectorAll('.vhero__body, .exhero__body, .veng .container').forEach(function (box) {
      Array.prototype.forEach.call(box.children, function (el, i) {
        mark(el, 'rv-block', i * 90);
      });
    });
    document.querySelectorAll('.vhero__media, .exhero__media').forEach(function (el) {
      mark(el, 'rv-block', 180);
    });

    /* Images éditoriales : l'image "se pose" (scale 1.06 -> 1). Galerie produit exclue. */
    [
      '.iwt__media', '.band__media', '.hotspots__stage', '.video-section__media'
    ].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) { mark(el, 'rv-img', 0); });
    });

    /* Groupes en cascade (70ms, plafonné à 5 pas) : grilles de cartes,
       pastilles réassurance, éléments des rituels, réassurances produit */
    [
      '.featured .grid', '.collection-list__grid', '.multicolumn__grid',
      '.pillars .grid', '.duo .grid', '.related .grid', '.coll-grid .grid',
      '.pills', '.rituel__body', '.reassure',
      '.vcroy__grid', '.vpil__grid', '.exm__grid', '.exrit__list'
    ].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (group) {
        Array.prototype.forEach.call(group.children, function (child, i) {
          mark(child, 'rv-block', Math.min(i, 5) * 70);
        });
      });
    });

    /* Cascade lente (150ms) : étapes du rituel et avis clients, l'une après l'autre */
    ['.steps .grid', '.reviews .grid'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (group) {
        Array.prototype.forEach.call(group.children, function (child, i) {
          mark(child, 'rv-block', Math.min(i, 5) * 150);
        });
      });
    });

    document.documentElement.classList.add('rv');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('rv-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    toReveal.forEach(function (el) { io.observe(el); });

    /* Parallaxe : image du héro, images des rituels, fond du diagnostic.
       L'image est sur-cadrée (scale 1.12) et glisse de ±5% max : jamais de bord visible. */
    var plxEls = [];
    document.querySelectorAll('.hero__img, .rituel__media, .diag__bg').forEach(function (el) {
      el.classList.add('plx');
      plxEls.push(el);
    });

    /* Texte scrubbé (phrase de conviction, page Valeurs) : chaque mot
       s'allume au fil du scroll. Les <em> sont préservés. */
    var scrubbed = [];
    document.querySelectorAll('.conviction p').forEach(function (p) {
      var words = [];
      var split = function (node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (child) {
          if (child.nodeType === 3) {
            var frag = document.createDocumentFragment();
            child.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
              var s = document.createElement('span');
              s.className = 'w';
              s.textContent = part;
              frag.appendChild(s);
              words.push(s);
            });
            node.replaceChild(frag, child);
          } else if (child.nodeType === 1) { split(child); }
        });
      };
      split(p);
      p.classList.add('scrub');
      scrubbed.push({ el: p, words: words });
    });

    if (plxEls.length || scrubbed.length) {
      var ticking = false;
      var render = function () {
        ticking = false;
        var vh = window.innerHeight;
        plxEls.forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.bottom < 0 || r.top > vh) return;
          var p = (r.top + r.height / 2 - vh / 2) / (vh / 2);
          p = Math.max(-1, Math.min(1, p));
          el.style.setProperty('--plx', (p * -5).toFixed(2) + '%');
        });
        scrubbed.forEach(function (s) {
          var r = s.el.getBoundingClientRect();
          var start = vh * 0.85;
          var end = vh * 0.35;
          var t = (start - r.top) / (start - end + r.height);
          t = Math.max(0, Math.min(1, t));
          var lit = t * s.words.length;
          s.words.forEach(function (w, i) {
            w.style.opacity = Math.max(0.12, Math.min(1, lit - i)).toFixed(2);
          });
        });
      };
      var onScroll = function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(render); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      render();
    }
  }
})();
